
const isDev = process.env.NODE_ENV !== 'production';
export default {

    //check if npm is running on dev or prod mode

    host: !isDev?'https://dswisej.dyndns.org/restapi/api':'http://192.168.0.250/restapi/api',
    firebase: {
        apiKey: "AIzaSyC5tgrqFBmI0RYFqCdWDkmvKvFyE-1CKQY",
        authDomain: "winlift-next-v3.firebaseapp.com",
        databaseURL: "https://winlift-next-v3.firebaseio.com",
        projectId: "winlift-next-v3",
        storageBucket: "winlift-next-v3.appspot.com",
        messagingSenderId: "27048859798",
        appId: "1:27048859798:web:942b0acbfe722172400ab7",
        measurementId: "G-THX82910G9"
    },
    vapidKey:"BGJT0xdpHqvTF7lOvIRFcpprvEZ5kY6ruZeEr5co_cOyNm8KSZ3G3Ep_YXRpTV-sFX6F4_u5OEYcTDUjr48usxA"
}



